import i18n from "i18next";

const resources = {
  ar: {
    clientSecret_placeholder: "أدخل سر العميل الخاص بـ DHS",
    clientSecret_testConnection: "اختبار الاتصال",
    clientSecret_success: "تم التحقق من سر العميل وحفظه بنجاح!",
    clientSecret_error: "فشل التحقق من سر العميل",
    clientSecret_new_placeholder: "أدخل سر عميل جديد",
    branches_title: "ربط الفروع برموز NPHIES",
    branches_columnName: "اسم الفرع",
    branches_columnCode: "رمز NPHIES",
    branches_columnSecret: "المفتاح السري",
    branch_change_secret: "تغيير",
    branch_cancel_secret_edit: "إلغاء",
    branch_configured: "مُعد",
    branch_not_configured: "غير مُعد",
    branch_save: "حفظ",
    branch_saved_success: "تم حفظ إعدادات الفرع بنجاح",
    branches_noChanges: "لا توجد تغييرات للإرسال",
    branches_error: "فشل تحديث الفروع",
    enter_nphies_code_placeholder: "أدخل رمز NPHIES",
    branch_configured_tooltip: "تم حفظ سر عميل DHS والتحقق منه لهذا الفرع. تشير هذه العلامة إلى سر العميل فقط ولا تعكس رمز NPHIES.",
    branch_secret_updated: "آخر تحديث لسر العميل {{date}}",
    branch_not_configured_tooltip: "لم يتم حفظ سر عميل DHS لهذا الفرع بعد. أدخله في عمود المفتاح السري ثم اضغط حفظ.",
    branches_columnCode_tooltip: "رمز منظمة DHS/NPHIES الخاص بالفرع، ويُرسل كرمز مقدم الخدمة في كل طلب DHS. يجب توفره مع سر العميل حتى يتمكن الفرع من معالجة طلبات DHS، لكنه لا يحدد علامة «مُعد».",
    branches_columnSecret_tooltip: "سر عميل DHS المستخدم لمصادقة هذا الفرع لدى DHS. حفظ سر صالح هو ما يضبط علامة «مُعد». لكل فرع سره الخاص، ولا يوجد سر موحد على مستوى الشركة."
  },
  en: {
    clientSecret_placeholder: "Enter your DHS Client Secret",
    clientSecret_testConnection: "Test Connection",
    clientSecret_success: "Client Secret validated and saved successfully!",
    clientSecret_error: "Failed to validate Client Secret",
    clientSecret_new_placeholder: "Enter new client secret",
    branches_title: "Map Branches to NPHIES Codes",
    branches_columnName: "Branch Name",
    branches_columnCode: "NPHIES Code",
    branches_columnSecret: "Client Secret",
    branch_change_secret: "Change",
    branch_cancel_secret_edit: "Cancel",
    branch_configured: "Configured",
    branch_not_configured: "Not configured",
    branch_save: "Save",
    branch_saved_success: "Branch settings saved successfully",
    branches_noChanges: "No changes to submit",
    branches_error: "Failed to update branches",
    enter_nphies_code_placeholder: "Enter NPHIES Code",
    branch_configured_tooltip: "The DHS Client Secret has been saved and validated for this branch. This badge tracks the Client Secret only — it does not reflect the NPHIES Code.",
    branch_secret_updated: "Client Secret last updated {{date}}",
    branch_not_configured_tooltip: "No DHS Client Secret has been saved for this branch yet. Enter one in the Client Secret column and press Save.",
    branches_columnCode_tooltip: "The branch's DHS/NPHIES organization code, sent as the provider code on every DHS request. A branch must have this as well as a Client Secret to process DHS requests, but it does not drive the Configured badge.",
    branches_columnSecret_tooltip: "The DHS Client Secret used to authenticate this branch with DHS. Saving a valid secret is what sets the Configured badge. Each branch has its own secret; there is no company-wide secret."
  },
  ckb: {
    clientSecret_placeholder: "کلیلەکەت لێرە بنووسە",
    clientSecret_testConnection: "تاقیکردنەوەی پەیوەندی",
    clientSecret_success: "کلیلەکە بە سەرکەوتوویی پشتڕاستکرایەوە!",
    clientSecret_error: "پشتڕاستکردنەوەی کلیلەکە سەرکەوتوو نەبوو",
    clientSecret_new_placeholder: "کلیلێکی نوێ بنووسە",
    branches_title: "بەستنەوەی لقەکان بە کۆدەکانی NPHIES",
    branches_columnName: "ناوی لق",
    branches_columnCode: "کۆدی NPHIES",
    branches_columnSecret: "نهێنی ڕاژەخواز",
    branch_change_secret: "گۆڕین",
    branch_cancel_secret_edit: "پاشگەزبوونەوە",
    branch_configured: "ڕێکخراوە",
    branch_not_configured: "ڕێک نەخراوە",
    branch_save: "پاشەکەوتکردن",
    branch_saved_success: "ڕێکخستنەکانی لق بە سەرکەوتوویی پاشەکەوت کرا",
    branches_noChanges: "هیچ گۆڕانکارییەک نییە بۆ ناردن",
    branches_error: "نوێکردنەوەی لقەکان سەرکەوتوو نەبوو",
    enter_nphies_code_placeholder: "کۆدی NPHIES بنووسە",
    branch_configured_tooltip: "نهێنی کڕیاری DHS بۆ ئەم لقە پاشەکەوت و پشتڕاست کراوەتەوە. ئەم نیشانەیە تەنها نهێنی کڕیار دەپشکنێت و کۆدی NPHIES ناگەیەنێت.",
    branch_secret_updated: "دوایین نوێکردنەوەی نهێنی کڕیار {{date}}",
    branch_not_configured_tooltip: "هێشتا هیچ نهێنیەکی کڕیاری DHS بۆ ئەم لقە پاشەکەوت نەکراوە. لە ستوونی نهێنی کڕیار بینووسە و پاشەکەوتی بکە.",
    branches_columnCode_tooltip: "کۆدی ڕێکخراوی DHS/NPHIES ی لقەکە، کە وەک کۆدی دابینکەر لە هەموو داواکارییەکی DHS دەنێردرێت. لق پێویستی بەمە هەیە لەگەڵ نهێنی کڕیار بۆ پرۆسێسکردنی داواکاری DHS، بەڵام نیشانەی «ڕێکخراوە» دیاری ناکات.",
    branches_columnSecret_tooltip: "نهێنی کڕیاری DHS کە بۆ ڕەسەنایەتی ئەم لقە لەگەڵ DHS بەکاردێت. پاشەکەوتکردنی نهێنیەکی دروست نیشانەی «ڕێکخراوە» دادەنێت. هەر لقێک نهێنی تایبەتی خۆی هەیە؛ هیچ نهێنیەکی گشتی کۆمپانیا نییە."
  },
  el: {
    clientSecret_placeholder: "Εισαγάγετε το DHS Client Secret",
    clientSecret_testConnection: "Έλεγχος Σύνδεσης",
    clientSecret_success: "Το Client Secret επικυρώθηκε με επιτυχία!",
    clientSecret_error: "Αποτυχία επικύρωσης Client Secret",
    clientSecret_new_placeholder: "Εισαγάγετε νέο client secret",
    branches_title: "Αντιστοίχιση Υποκαταστημάτων σε Κωδικούς NPHIES",
    branches_columnName: "Όνομα Υποκαταστήματος",
    branches_columnCode: "Κωδικός NPHIES",
    branches_columnSecret: "Μυστικό πελάτη",
    branch_change_secret: "Αλλαγή",
    branch_cancel_secret_edit: "Ακύρωση",
    branch_configured: "Διαμορφωμένο",
    branch_not_configured: "Μη διαμορφωμένο",
    branch_save: "Αποθήκευση",
    branch_saved_success: "Οι ρυθμίσεις του υποκαταστήματος αποθηκεύτηκαν",
    branches_noChanges: "Δεν υπάρχουν αλλαγές προς υποβολή",
    branches_error: "Αποτυχία ενημέρωσης υποκαταστημάτων",
    enter_nphies_code_placeholder: "Εισαγάγετε κωδικό NPHIES",
    branch_configured_tooltip: "Το DHS Client Secret έχει αποθηκευτεί και επαληθευτεί για αυτό το υποκατάστημα. Η ένδειξη αφορά μόνο το Client Secret — δεν αντικατοπτρίζει τον κωδικό NPHIES.",
    branch_secret_updated: "Τελευταία ενημέρωση Client Secret {{date}}",
    branch_not_configured_tooltip: "Δεν έχει αποθηκευτεί ακόμη DHS Client Secret για αυτό το υποκατάστημα. Εισαγάγετέ το στη στήλη Client Secret και πατήστε Αποθήκευση.",
    branches_columnCode_tooltip: "Ο κωδικός οργανισμού DHS/NPHIES του υποκαταστήματος, που αποστέλλεται ως κωδικός παρόχου σε κάθε αίτημα DHS. Απαιτείται μαζί με το Client Secret για την επεξεργασία αιτημάτων DHS, αλλά δεν καθορίζει την ένδειξη «Διαμορφωμένο».",
    branches_columnSecret_tooltip: "Το DHS Client Secret που χρησιμοποιείται για την πιστοποίηση αυτού του υποκαταστήματος στο DHS. Η αποθήκευση έγκυρου κωδικού είναι αυτό που ενεργοποιεί την ένδειξη «Διαμορφωμένο». Κάθε υποκατάστημα έχει το δικό του· δεν υπάρχει κοινός κωδικός εταιρείας."
  },
  fr: {
    clientSecret_placeholder: "Entrez votre Secret Client DHS",
    clientSecret_testConnection: "Tester la Connexion",
    clientSecret_success: "Secret Client validé et enregistré !",
    clientSecret_error: "Échec de la validation du Secret Client",
    clientSecret_new_placeholder: "Entrer le nouveau secret client",
    branches_title: "Mapper les Succursales aux Codes NPHIES",
    branches_columnName: "Nom de la Succursale",
    branches_columnCode: "Code NPHIES",
    branches_columnSecret: "Secret client",
    branch_change_secret: "Modifier",
    branch_cancel_secret_edit: "Annuler",
    branch_configured: "Configuré",
    branch_not_configured: "Non configuré",
    branch_save: "Enregistrer",
    branch_saved_success: "Paramètres de la succursale enregistrés",
    branches_noChanges: "Aucune modification à soumettre",
    branches_error: "Échec de la mise à jour des succursales",
    enter_nphies_code_placeholder: "Entrez le Code NPHIES",
    branch_configured_tooltip: "Le Client Secret DHS a été enregistré et validé pour cette succursale. Ce badge concerne uniquement le Client Secret — il ne reflète pas le code NPHIES.",
    branch_secret_updated: "Client Secret mis à jour le {{date}}",
    branch_not_configured_tooltip: "Aucun Client Secret DHS n'a encore été enregistré pour cette succursale. Saisissez-le dans la colonne Client Secret puis cliquez sur Enregistrer.",
    branches_columnCode_tooltip: "Le code d'organisation DHS/NPHIES de la succursale, envoyé comme code prestataire à chaque requête DHS. Il est requis en plus du Client Secret pour traiter les requêtes DHS, mais ne détermine pas le badge « Configuré ».",
    branches_columnSecret_tooltip: "Le Client Secret DHS utilisé pour authentifier cette succursale auprès de DHS. L'enregistrement d'un secret valide est ce qui active le badge « Configuré ». Chaque succursale a le sien ; il n'existe pas de secret commun à l'entreprise."
  },
  it: {
    clientSecret_placeholder: "Inserisci il tuo Secret Client DHS",
    clientSecret_testConnection: "Test Connessione",
    clientSecret_success: "Secret Client validato con successo!",
    clientSecret_error: "Validazione Secret Client fallita",
    clientSecret_new_placeholder: "Inserisci nuovo client secret",
    branches_title: "Mappa Filiali ai Codici NPHIES",
    branches_columnName: "Nome Filiale",
    branches_columnCode: "Codice NPHIES",
    branches_columnSecret: "Segreto client",
    branch_change_secret: "Modifica",
    branch_cancel_secret_edit: "Annulla",
    branch_configured: "Configurato",
    branch_not_configured: "Non configurato",
    branch_save: "Salva",
    branch_saved_success: "Impostazioni della filiale salvate correttamente",
    branches_noChanges: "Nessuna modifica da inviare",
    branches_error: "Aggiornamento filiali fallito",
    enter_nphies_code_placeholder: "Inserisci Codice NPHIES",
    branch_configured_tooltip: "Il Client Secret DHS è stato salvato e convalidato per questa filiale. Questo badge riguarda solo il Client Secret — non riflette il codice NPHIES.",
    branch_secret_updated: "Client Secret aggiornato il {{date}}",
    branch_not_configured_tooltip: "Nessun Client Secret DHS è ancora stato salvato per questa filiale. Inseriscilo nella colonna Client Secret e premi Salva.",
    branches_columnCode_tooltip: "Il codice organizzazione DHS/NPHIES della filiale, inviato come codice fornitore in ogni richiesta DHS. È necessario insieme al Client Secret per elaborare le richieste DHS, ma non determina il badge «Configurato».",
    branches_columnSecret_tooltip: "Il Client Secret DHS usato per autenticare questa filiale presso DHS. Il salvataggio di un secret valido è ciò che attiva il badge «Configurato». Ogni filiale ha il proprio; non esiste un secret aziendale unico."
  },
  ku: {
    clientSecret_placeholder: "Client Secret a xwe binivîse",
    clientSecret_testConnection: "Girêdanê tespît bike",
    clientSecret_success: "Client Secret hat pesendkirin û tomar kirin!",
    clientSecret_error: "Client Secret nehat pesendkirin",
    clientSecret_new_placeholder: "Client Secret a nû binivîse",
    branches_title: "Şaxan bi Kodên NPHIES ve girê bide",
    branches_columnName: "Navê Şaxê",
    branches_columnCode: "Koda NPHIES",
    branches_columnSecret: "Nihêniya klîentê",
    branch_change_secret: "Guhertin",
    branch_cancel_secret_edit: "Betalkirin",
    branch_configured: "Mîhengkirî",
    branch_not_configured: "Nemîhengkirî",
    branch_save: "Tomarkirin",
    branch_saved_success: "Mîhengên şaxê bi serkeftî hatin tomarkirin",
    branches_noChanges: "Guhertinek tune ye",
    branches_error: "Şax nehatin nûkirin",
    enter_nphies_code_placeholder: "Koda NPHIES binivîse",
    branch_configured_tooltip: "Client Secret ya DHS ji bo vê şaxê hat tomarkirin û pejirandin. Ev nîşan tenê Client Secret dişopîne — koda NPHIES nîşan nade.",
    branch_secret_updated: "Client Secret dawî hat nûkirin {{date}}",
    branch_not_configured_tooltip: "Hêj tu Client Secret ya DHS ji bo vê şaxê nehatiye tomarkirin. Wê di stûna Client Secret de binivîse û Tomar bike.",
    branches_columnCode_tooltip: "Koda rêsxistinê ya DHS/NPHIES ya şaxê, ku di her daxwaza DHS de wek koda pêşkêşkar tê şandin. Bi Client Secret re pêwîst e da ku şax daxwazên DHS bi rê ve bibe, lê nîşana «Mîhengkirî» diyar nake.",
    branches_columnSecret_tooltip: "Client Secret ya DHS ku ji bo naskirina vê şaxê li cem DHS tê bikaranîn. Tomarkirina secretek derbasdar e ku nîşana «Mîhengkirî» çalak dike. Her şax ya xwe heye; tu secretek giştî ya pargîdaniyê tune."
  },
  nl: {
    clientSecret_placeholder: "Voer uw DHS Client Secret in",
    clientSecret_testConnection: "Verbinding testen",
    clientSecret_success: "Client Secret succesvol gevalideerd!",
    clientSecret_error: "Valideren van Client Secret mislukt",
    clientSecret_new_placeholder: "Voer nieuw client secret in",
    branches_title: "Filialen koppelen aan NPHIES-codes",
    branches_columnName: "Filiaalnaam",
    branches_columnCode: "NPHIES-code",
    branches_columnSecret: "Clientgeheim",
    branch_change_secret: "Wijzigen",
    branch_cancel_secret_edit: "Annuleren",
    branch_configured: "Geconfigureerd",
    branch_not_configured: "Niet geconfigureerd",
    branch_save: "Opslaan",
    branch_saved_success: "Vestigingsinstellingen opgeslagen",
    branches_noChanges: "Geen wijzigingen om in te dienen",
    branches_error: "Bijwerken van filialen mislukt",
    enter_nphies_code_placeholder: "Voer NPHIES-code in",
    branch_configured_tooltip: "Het DHS Client Secret is opgeslagen en gevalideerd voor deze vestiging. Dit label geldt alleen voor het Client Secret — het weerspiegelt niet de NPHIES-code.",
    branch_secret_updated: "Client Secret laatst bijgewerkt op {{date}}",
    branch_not_configured_tooltip: "Er is nog geen DHS Client Secret opgeslagen voor deze vestiging. Voer er een in in de kolom Client Secret en klik op Opslaan.",
    branches_columnCode_tooltip: "De DHS/NPHIES-organisatiecode van de vestiging, die bij elke DHS-aanvraag als zorgaanbiedercode wordt verzonden. Vereist naast het Client Secret om DHS-aanvragen te verwerken, maar bepaalt niet het label 'Geconfigureerd'.",
    branches_columnSecret_tooltip: "Het DHS Client Secret waarmee deze vestiging zich bij DHS authenticeert. Het opslaan van een geldig secret bepaalt het label 'Geconfigureerd'. Elke vestiging heeft een eigen secret; er is geen bedrijfsbreed secret."
  },
  pl: {
    clientSecret_placeholder: "Wprowadź DHS Client Secret",
    clientSecret_testConnection: "Testuj połączenie",
    clientSecret_success: "Client Secret pomyślnie zweryfikowany!",
    clientSecret_error: "Błąd weryfikacji Client Secret",
    clientSecret_new_placeholder: "Wprowadź nowy client secret",
    branches_title: "Mapuj oddziały do kodów NPHIES",
    branches_columnName: "Nazwa oddziału",
    branches_columnCode: "Kod NPHIES",
    branches_columnSecret: "Klucz klienta",
    branch_change_secret: "Zmień",
    branch_cancel_secret_edit: "Anuluj",
    branch_configured: "Skonfigurowano",
    branch_not_configured: "Nie skonfigurowano",
    branch_save: "Zapisz",
    branch_saved_success: "Ustawienia oddziału zostały zapisane",
    branches_noChanges: "Brak zmian do wysłania",
    branches_error: "Błąd aktualizacji oddziałów",
    enter_nphies_code_placeholder: "Wprowadź kod NPHIES",
    branch_configured_tooltip: "Client Secret DHS został zapisany i zweryfikowany dla tego oddziału. Ta etykieta dotyczy wyłącznie Client Secret — nie odzwierciedla kodu NPHIES.",
    branch_secret_updated: "Client Secret ostatnio zaktualizowano {{date}}",
    branch_not_configured_tooltip: "Dla tego oddziału nie zapisano jeszcze Client Secret DHS. Wprowadź go w kolumnie Klucz klienta i naciśnij Zapisz.",
    branches_columnCode_tooltip: "Kod organizacji DHS/NPHIES oddziału, wysyłany jako kod świadczeniodawcy w każdym żądaniu DHS. Jest wymagany obok Client Secret, aby oddział mógł przetwarzać żądania DHS, ale nie decyduje o etykiecie „Skonfigurowano”.",
    branches_columnSecret_tooltip: "Client Secret DHS służący do uwierzytelniania tego oddziału w DHS. Zapisanie prawidłowego klucza ustawia etykietę „Skonfigurowano”. Każdy oddział ma własny klucz; nie ma klucza wspólnego dla firmy."
  }
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("ar", "dhsIntegration", resources.ar);
  i18next.addResourceBundle("en", "dhsIntegration", resources.en);
  i18next.addResourceBundle("ckb", "dhsIntegration", resources.ckb);
  i18next.addResourceBundle("el", "dhsIntegration", resources.el);
  i18next.addResourceBundle("fr", "dhsIntegration", resources.fr);
  i18next.addResourceBundle("it", "dhsIntegration", resources.it);
  i18next.addResourceBundle("ku", "dhsIntegration", resources.ku);
  i18next.addResourceBundle("nl", "dhsIntegration", resources.nl);
  i18next.addResourceBundle("pl", "dhsIntegration", resources.pl);

};
